(ns hai.admin-ui.users.routes
  (:require
   [hai.admin-ui.users.edit :as edit]
   [hai.admin-ui.users.groups.routes :as groups.routes]
   [hai.admin-ui.users.table :as table]
   [hai.ui.icons :as icons]
   [hai.web-app.routing :as routing]))

(defn routes
  []
  [(-> ["/users"
        {::routing/window-title "Users"
         :label/short "Users"
         :icon icons/outlined-person}
        ["" {:name :users
             :label "Manage Users"
             :view table/page}]]
       (conj (edit/route))
       (into (groups.routes/routes)))])
